import * as React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { blue, purple, red, green, orange, brown } from '@mui/material/colors';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { ThemeProvider, createTheme }, "@mui/material/colors": { blue, purple, red, green, orange, brown }, "@mui/material/Box": Box, "@mui/material/Button": Button, "@mui/material/Typography": Typography } } });
export default ClientProvider;
